<template>
<b-container fluid>
  <bo-page-title />

  <b-card no-body>
    <b-card-header>
      <b-row>
        <b-col lg="5">
          <h5 class="card-title">{{ pageTitle }} List</h5>
        </b-col>
        <b-col lg="3">
        </b-col>
        <b-col lg="4">
          <SearchInput :value.sync="filter.search" @search="doFilter" />
        </b-col>
      </b-row>
    </b-card-header>
    <b-card-body class="p-0">
      <b-table
        :fields="fields"
        :items="dataList||[]"
        :primary-key="idKey"
        :busy="!dataList"
        @sort-changed="sorting"
        :no-local-sorting="true"
        responsive
        show-empty
        striped
      >
        <template #empty>
          <div class="text-center">
            <b-img class="mb-2" width="90" fluid src="/assets/images/no-data.png" />
            <h4 align="center"><span v-if="Object.keys($route.query).length">No search results found</span><span v-else>No {{ pageTitle }} listed yet</span></h4>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-3 text-info"></b-spinner>
            <strong class="text-info">Loading...</strong>
          </div>
        </template>
        <template #cell(number)="v">
          {{(data.per_page*(data.current_page-1))+v.index+1}}
        </template>
        <template #cell(ar_event_date)="data">
          {{ data.item.ar_event_date | moment("DD MMM YYYY") }}
          <span class="d-inline-block">
            {{ '2025-01-01 ' + data.item.ar_event_time | moment("HH:mm") }}
          </span>
          <div>
            <ul class="list-unstyled">
              <li>
                <small>
                  Reminded <b>{{ data.item.ar_remind_before_minutes }} minutes</b> before
                </small>
              </li>
              <li v-if="data.item.ar_is_repeat === 'Y'">
                <small>
                  Repeat every {{ data.item.ar_repeat_every }} 
                  <span v-if="data.item.ar_repeat_every === 'WEEKLY'">
                    on {{ data.item.ar_repeat_on }}
                  </span>
                  <span v-else-if="data.item.ar_repeat_every === 'MONTHLY'">
                    on {{ data.item.ar_repeat_on + '-12-2025' | moment("Do") }}
                  </span>
                  <span v-else-if="data.item.ar_repeat_every === 'YEARLY'">
                    on {{ data.item.ar_repeat_on + '-2025' | moment("Do of MMMM") }}
                  </span>
                </small>
              </li>
            </ul>
          </div>
        </template>
        <template #cell(ar_is_active)="data">
          <div>
            <span :class="{
              'badge p-2': true,
              'bg-danger': data.value === 'N',
              'bg-success': data.value === 'Y'
            }">{{ data.value === 'Y' ? 'ACTIVE' : 'INACTIVE' }}</span>
          </div>
        </template>
        <template #cell(ar_title)="data">
          <p class="mb-1" style="font-weight:500">
            <a @click="open(data.item)" href="javascript:;">
              {{ data.value }}
            </a>
          </p>
          <template v-if="(data.item.ar_tags||[]).length">
            <span v-for="(v, k) in data.item.ar_tags" :key="k" class="badge border border-info text-info mr-1"
            >{{ v }}</span>
          </template>
        </template>
        <template #cell(latest_updated)="data">
          {{(data.item.ar_updated_at||data.item.ar_created_at) | moment("DD MMM YYYY HH:mm:ss")}}
        </template>
        <template
          #cell(action)="data"
        >
          <a @click="open(data.item)"
            href="javascript:;"
            v-b-tooltip.hover
            title="View"
            class="icon_action"
            style="cursor:pointer;"
          >
            <i class="ti-eye"></i>
          </a>
          <router-link
            v-if="moduleRole('edit')"
            v-b-tooltip.hover
            title="Edit"
            class="icon_action"
            :to="{name: $route.name, params: {pageSlug: data.item[idKey]}}"
            style="cursor:pointer;"
          >
            <i class="ti-marker-alt"></i>
          </router-link>
          <a
            v-if="moduleRole('delete')"
            v-b-tooltip.hover
            title="Delete"
            class="icon_action"
            @click="doDelete(data.index, data.item)"
            style="cursor:pointer;"
          >
            <i class="ti-trash"></i>
          </a>
        </template>
      </b-table>
    </b-card-body>
    <b-card-footer>
      <template v-if="(dataList||[]).length&&data.total>10">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <label for="perPage" class="mb-0 mr-2">Show</label>
              <b-form-select
                size="sm"
                id="perPage"
                class="w-auto mx-50"
                v-model="perPage"
                :options="Config.dataShownOptions"
              />
            <label for="perPage" class="mb-0 ml-2">items per page</label>
          </div>
          <b-pagination
            class="mb-0"
            v-model="pageNo"
            :per-page="data.per_page"
            :total-rows="data.total"
          />
        </div>
      </template>
    </b-card-footer>
  </b-card>

  <template v-if="isList">
    <b-modal
      v-model="view"
      title="Detail Reminder"
      centered
      hide-footer
      size="xl"
    >
      <b-card v-if="row.ar_id" no-body class="m-0">
        <b-card-body>
          <b-row>
            <b-col lg="4">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">{{ row.ar_is_repeat === 'Y' ? 'Start ' : '' }}Date</span>
                <h6 style="font-weight: 400;">
                  {{(row.ar_event_date) | moment("DD MMMM YYYY")}}
                </h6>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">{{ row.ar_is_repeat === 'Y' ? 'Start ' : '' }}Time</span>
                <h6 style="font-weight: 400;">
                  {{('2025-01-01 '+row.ar_event_time) | moment("HH:mm")}}
                </h6>
              </div>
            </b-col>
            <b-col lg="4" align="right">
              <div align="right">
                <b-button type="button" variant="info" :to="{name: $route.name, params: {pageSlug: row[idKey]}}">Edit</b-button>
              </div>
            </b-col>

            <div class="clearfix w-100 m-0" />

            <b-col lg="4">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">Reminded Before</span>
                <h6 style="font-weight: 400;">
                  {{row.ar_remind_before_minutes}} minutes
                </h6>
              </div>
            </b-col>

            <b-col lg="12">
              <div class="detail-info">
                <span style="font-size: 12px;font-weight: 400;">Remind To</span>
                <div v-if="(row.ar_slack_assignees||[]).length">
                  <span v-for="(v, k) in getSlackUsers(row.ar_slack_assignees)" :key="k" class="badge border border-info text-info mr-1"
                  >{{ v.user_name }}</span>
                </div>
              </div>
            </b-col>

            <div class="clearfix w-100 m-0" />

            <template v-if="row.ar_is_repeat === 'Y'">
              <b-col lg="4">
                <div class="detail-info">
                  <span style="font-size: 12px;font-weight: 400;">Repeat Every</span>
                  <h6 style="font-weight: 400;">
                    {{ row.ar_repeat_every }}
                  </h6>
                </div>
              </b-col>
              <b-col lg="4">
                <div class="detail-info">
                  <span style="font-size: 12px;font-weight: 400;">On</span>
                  <h6 style="font-weight: 400;">
                    {{ labelRepeatOn(row.ar_repeat_every, row.ar_event_date) }}
                  </h6>
                </div>
              </b-col>
              <b-col lg="4">
                <div class="detail-info">
                  <span style="font-size: 12px;font-weight: 400;">Ends</span>
                  <h6 style="font-weight: 400;">
                    {{ row.ar_repeat_end === 'DATE' ? $moment(row.ar_repeat_end_after).format('DD MMMM YYYY') : row.ar_repeat_end }}
                  </h6>
                </div>
              </b-col>
            </template>
          </b-row>

          <hr />

          <b-row>
            <b-col md="12">
              <b-row>
                <b-col md="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Status</span>
                    <h6 style="font-weight: 400;">
                      <span :class="{
                        'badge p-2': true,
                        'bg-danger': row.ar_is_active === 'N',
                        'bg-success': row.ar_is_active === 'Y'
                      }">{{ row.ar_is_active === 'Y' ? 'ACTIVE' : 'INACTIVE' }}</span>
                    </h6>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Creator</span>
                    <h6 style="font-weight: 400;">{{ row.ar_creator }}</h6>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Latest Updated</span>
                    <h6 style="font-weight: 400;">
                      {{(row.ar_updated_at||row.ar_created_at) | moment("DD MMM YYYY HH:mm:ss")}}
                    </h6>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <b-row>
                <b-col lg="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Title</span>
                    <h6 style="font-weight: 400;">
                      {{ row.ar_title }}
                    </h6>
                  </div>
                </b-col>
                <b-col v-if="(row.ar_tags||[]).length" lg="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Tags</span>
                    <div>
                      <span v-for="(v, k) in row.ar_tags" :key="k" class="badge border border-info text-info mr-1"
                      >{{ v }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col lg="4">
                  <div class="detail-info">
                    <span style="font-size: 12px;font-weight: 400;">Description</span>
                    <h6 style="font-weight: 400;">
                      {{ row.ar_title }}
                    </h6>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
  </template>

  <template v-if="!isList">
    <Form :pageSlug.sync="formSlug" :rowModal.sync="row" />
  </template>
</b-container>
</template>
<script>
import GlobalVue from '@/libs/Global.vue'
import Form from './Form.vue'
const _ = global._

export default {
  extends: GlobalVue,
  components:{Form},
  data() {
    return {
      formSlug: '',
      idKey:'ar_id',
      statusKey:'',
      mrValidation: {},
      dataModal: {},
      fields: [
        {
          key: 'number', label: '#', 
        },
        {
          key: 'ar_event_date', label: 'Date/Time', sortable: true, sortKey: 'ar_event_date'
        },
        {
          key: 'ar_title', label: 'Title', sortable: true, sortKey: 'ar_title'
        },
        {
          key: 'ar_is_active', label: 'Status',
        },
        {
          key: 'ar_creator', label: 'Creator',
        },
        {
          key: 'latest_updated', label: 'Latest Updated',
        },
        {
          key: 'action', 
        },
      ],
      view: false,
      row: {},
      mrSlackUsers: []
    }
  },
  mounted(){
    if (this.isList) {
      this.apiGet({
        query: {
          getSlackUsers: 'Y'
        }
      })
    }
  },
  methods: {
    getSlackUsers(ids) {
      return _.filter(this.mrSlackUsers, v => {
        return ids.indexOf(v.user_id) > -1
      })
    },
    labelRepeatOn(every, date) {
      if (every === 'DAILY') {
        return 'EVERY DAY'
      } else if (every === 'WEEKLY') {
        return this.$moment(date).format('dddd').toUpperCase()
      } else if (every === 'MONTHLY') {
        return this.$moment(date).format('Do')
      } else if (every === 'YEARLY') {
        return this.$moment(date).format('Do of MMMM')
      } else {
        return ''
      }
    },
    sorting(e){
      this.filter.sort = e.sortBy + '-' + (e.sortDesc ? 'desc' : 'asc')
      this.$nextTick(() => {
        this.doFilter()
      })
    },
    open(item) {
      this.row = item
      this.$nextTick(() => {
        this.view = true
      })
    }
  },
  watch:{
    $route(){
      if (this.isList && this.formSlug !== 'canceled') {
        this.apiGet()
      }
    },
    '$route.params.pageSlug': function(v) {
      this.formSlug = v
    }
  }
}
</script>